import { ProductCardProps, Taxonomy } from 'home/types/types';

declare global {
  interface Window {
    dataLayer: any[];
  }
}

type EventParams = {
  [key: string]: any;
};

export default class GoogleEvent {
  private readonly _eventName: string;
  private _eventParams: EventParams;

  constructor(eventName: string, eventParams: EventParams = {}) {
    this._eventName = eventName;
    this._eventParams = eventParams;
  }

  set eventParams(value: EventParams) {
    this._eventParams = value;
  }

  public sendEvent() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: this._eventName,
      ...this._eventParams,
    });
  }

  public getStructuredItemsFromProducts(products: ProductCardProps[], listId: number | string, listName: string) {
    return products.map((product) => {
      const categories = GoogleEvent.generateItemCategories(product.categories);

      return {
        item_id: product.id,
        item_name: product.title,
        affiliation: product.urlDomain,
        item_brand: product.brand?.name || '',
        ...categories,
        item_list_id: listId,
        item_list_name: listName,
        price: product.priceAmountNum,
      };
    });
  }

  static generateItemCategories(productCategories: Taxonomy[] | undefined) {
    return (productCategories ?? []).reduce(
      (acc: { [key: string]: string }, category: { name: string }, index: number) => {
        const key = index === 0 ? 'item_category' : `item_category${index + 1}`;
        acc[key] = category.name;
        return acc;
      },
      {}
    );
  }
}
